import React from 'react';
export const CFIconMoreVertical = {
    alias: 'more-vertical',
    defaultTitle: 'More Vertical',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M12 7a2 2 0 1 0-.001-4.001A2 2 0 0 0 12 7Zm0 3a2 2 0 1 0 .001 4.001A2 2 0 0 0 12 10Zm-2 9a2 2 0 1 1 4.001.001A2 2 0 0 1 10 19Z' }))),
};
